/**
 * Keeps the division filter selection aligned with the divisions the user can access.
 * Prunes stale ids from the current selection; restores persisted ids only when empty.
 */
export const resolveSelectedDivisionIds = (
  allDivsIds: string[],
  selectedDivs: string[],
  savedDivsFromStorage: string[] = [],
): string[] => {
  if (!allDivsIds.length) {
    return [];
  }

  const prunedCurrent = selectedDivs.filter(id => allDivsIds.includes(id));
  if (prunedCurrent.length) {
    return prunedCurrent;
  }

  const prunedSaved = savedDivsFromStorage.filter(id => allDivsIds.includes(id));
  return prunedSaved.length ? prunedSaved : allDivsIds;
};
